export const MEMBER_TYPE_CHANGE_ROUTE = 'member-type-change';

export const MEMBER_TYPE_CHANGE_STATUS = {
    ELIGIBLE: 'Eligible',
    NOT_ELIGIBLE: 'Not Eligible'
} as const;

export const MEMBER_TYPE_CHANGE_ERROR_MESSAGES = {
    REQUIRED: 'Wallet address is required',
    INVALID_WALLET: 'Please enter a valid Ethereum wallet address',
    GENERIC: 'Unable to search user right now. Please try again.'
} as const;

/** Environments where the "Shift to AMC Window" button is offered. Production never gets it. */
export type AmcWindowShiftEnvironment = 'development' | 'staging';

export interface AmcWindowShiftInstructions {
    label: string;
    message: string;
}

/** Shown in the confirmation popup. Static HTML: the Fuse dialog renders `message` with innerHTML. */
export const AMC_WINDOW_SHIFT_INSTRUCTIONS: Record<AmcWindowShiftEnvironment, AmcWindowShiftInstructions> = {
    development: {
        label: 'Development',
        message: '<strong>For testing only.</strong> The test transactions created on the <strong>Development</strong> backend are moved so that'
            + ' their dates fall inside the AMC initiative period, as if they had been contributed during it.'
            + '<br><br>This option exists only on Development and Staging. It is not available in Production.'
            + ' The new dates are saved straight away and cannot be undone from this panel.'
    },
    staging: {
        label: 'Staging',
        message: '<strong>For testing only.</strong> The test transactions created on the <strong>Staging</strong> backend are moved so that'
            + ' their dates fall inside the AMC initiative period, as if they had been contributed during it.'
            + '<br><br>This option exists only on Development and Staging. It is not available in Production.'
            + ' Staging data is shared with QA, so run it only when the team expects it. The new dates are saved straight away and cannot be undone from this panel.'
    }
};

export const AMC_WINDOW_SHIFT_SUCCESS_MESSAGE = 'Transactions shifted to the AMC window';
export const AMC_WINDOW_SHIFT_ERROR_MESSAGE = 'Unable to shift transactions to the AMC window right now. Please try again.';

/** The environment the button runs in, or `null` when it must stay hidden (production or an unknown name). */
export function amcWindowShiftEnvironment(env: { production: boolean; ENVIRONMENT_NAME?: string }): AmcWindowShiftEnvironment | null {
    if (env.production) {
        return null;
    }
    return env.ENVIRONMENT_NAME === 'development' || env.ENVIRONMENT_NAME === 'staging' ? env.ENVIRONMENT_NAME : null;
}
